window._mode='front';window._protocol='https://';window._domain='www.votre-etiquette.com';window._diroot='';window._theme='default';window._webdir='web';window._themedir='web/_themes/ve/';window._api='/api/v2/';
import Interface from 'theme/index.js';
Interface();
import Spinner from 'components/spinner.js';

document.addEventListener('DOMContentLoaded', function()
{
    document.querySelectorAll('.form-form').forEach(form =>
    {
        form.addEventListener('submit', function(event)
        {
            
            form.querySelectorAll('button.form-submit-button').forEach(el =>
            {
                el.setAttribute('disabled', 'disabled');
                Spinner.set({
                    target: el,
                    mode: 'button'
                });
            });
        });
    });
});